<template>
  <div class="lobby-list">
    <Header title="Últimas partidas do club"></Header>
    <div class="container">
      <LobbiesTable :lobbies="lobbies"></LobbiesTable>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import LobbiesTable from "@/components/LobbiesTable";
export default {
  name: "ClubLobbies",
  metaInfo: {
    title: "Últimas partidas do club"
  },
  data() {
    return {
      lobbies: []
    };
  },
  methods: {
    initialize() {
      this.$http
        .get(`clubs/${this.$route.params.id}/lobbies.json`)
        .then(response => (this.lobbies = response.data));
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    Header,
    LobbiesTable
  }
};
</script>
